<template>
  <div>
    <div class="flex items-start">
      <div class="flex-shrink-0 flex items-center w-52">
        <TelegramIcon class="w-8 h-8 flex-shrink-0 mr-3"/>
        <div style="color: #31a9dc" class="uppercase text-lg font-bold">Telegram</div>
      </div>
      <div>
        <div v-if="profile.telegramChatId">
          <span class="font-medium mr-2">{{ $lang.app.TELEGRAM_USER_ID }}:</span>
          <span class="font-bold mr-2">{{ profile.telegramChatId }}</span>
          <button type="button"
                  class="px-2 py-1 text-sm text-center text-white bg-red-600 hover:bg-red-500 rounded-md focus:outline-none mr-4"
                  @click="removeTelegramUserId">
            <TrashIcon class="w-5 h-5"/>
          </button>
        </div>
        <ol v-else class="list-decimal">
          <li class="mb-4">
            <span class="font-medium mr-2">{{ $lang.app.SUBSCRIBE_TO_TELEGRAM_BOT }}</span>
            <a :href="systemTelegramBotUrl" target="_blank" class="text-blue-500 font-medium">Gosstroy</a>
            <span class="block font-normal text-sm text-gray-600">({{ $lang.app.BY_CLICKING_START_BUTTON }})</span>
          </li>
          <li>
            <span class="font-medium mr-2">{{ $lang.app.ADD_TELEGRAM_USER_ID }}</span>
            <button type="button"
                    class="px-4 py-1 text-sm text-center text-white bg-blue-600 hover:bg-blue-500 rounded-md focus:outline-none mr-4"
                    @click="$emitter.emit('open-telegram-form-modal')">
              {{ $lang.app.ADD }}
            </button>
          </li>
        </ol>
      </div>
    </div>
    <TelegramFormModal/>
  </div>
</template>
<script>
import telegramApi from "../../../api/employee/telegram";
import TelegramFormModal from "../../../components/employee/profile/TelegramFormModal";

export default {
  props: {
    profile: Object
  },
  components: {
    TelegramFormModal
  },
  data() {
    return {
      systemTelegramBotUrl: ''
    }
  },
  created() {
    this.fetchSystemTelegramBotUrl()
  },
  methods: {
    fetchSystemTelegramBotUrl() {
      telegramApi.systemBotUrl().then(res => {
        this.systemTelegramBotUrl = res.url
      })
    },
    removeTelegramUserId() {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          telegramApi.deleteUserId()
              .then(() => {
                this.$emitter.emit('refresh-profile')
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    }
  }
}
</script>